// ALTIORA Career OS data-testid registry
export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  loginPasswordToggle: "auth-login-password-toggle",
  loginRememberMe: "auth-login-remember-me",
  loginForgotLink: "auth-login-forgot-link",
  signupName: "auth-signup-name",
  signupFirstName: "auth-signup-first-name",
  signupLastName: "auth-signup-last-name",
  signupUsername: "auth-signup-username",
  signupEmail: "auth-signup-email",
  signupPassword: "auth-signup-password",
  signupPasswordConfirm: "auth-signup-password-confirm",
  signupAcceptTerms: "auth-signup-accept-terms",
  signupSubmit: "auth-signup-submit",
  forgotEmail: "auth-forgot-email",
  forgotSubmit: "auth-forgot-submit",
  resetPassword: "auth-reset-password",
  resetConfirm: "auth-reset-confirm",
  resetSubmit: "auth-reset-submit",
  googleBtn: "auth-google-btn",
  msBtn: "auth-microsoft-btn",
  appleBtn: "auth-apple-btn",
  linkedinBtn: "auth-linkedin-btn",
  githubBtn: "auth-github-btn",
  guestBtn: "auth-guest-btn",
  linkLogin: "auth-link-login",
  linkSignup: "auth-link-signup",
};

export const LANDING = {
  ctaPrimary: "landing-cta-primary",
  ctaSecondary: "landing-cta-secondary",
  langSwitcher: "landing-lang-switcher",
  navLogin: "landing-nav-login",
  navSignup: "landing-nav-signup",
};

export const NAV = {
  logout: "nav-logout",
  langSwitcher: "nav-lang-switcher",
  dashboard: "nav-dashboard",
  modules: "nav-modules",
  finance: "nav-finance",
  governance: "nav-governance",
  admin: "nav-admin",
  gps: "nav-gps",
  discovery: "nav-discovery",
  knowledge: "nav-knowledge",
  library: "nav-library",
  studio: "nav-studio",
  alerts: "nav-alerts",
  professionals: "nav-professionals",
  lifeStrategy: "nav-life-strategy",
  trust: "nav-trust",
  profile: "nav-profile",
  intelligence: "nav-intelligence",
  opportunities: "nav-opportunities",
  hiddenOpportunities: "nav-hidden-opportunities",
  decision: "nav-decision",
  simulation: "nav-simulation",
  mobility: "nav-mobility",
  graph: "nav-graph",
  memory: "nav-memory",
  vault: "nav-vault",
  documents: "nav-documents",
  tracker: "nav-tracker",
  calendar: "nav-calendar",
  assistant: "nav-assistant",
  connectors: "nav-connectors",
  partner: "nav-partner",
  partnerDirectory: "nav-partner-directory",
  founder: "nav-founder",
  reports: "nav-reports",
  whiteLabel: "nav-white-label",
  enterpriseApi: "nav-enterprise-api",
  knowledgeSources: "nav-knowledge-sources",
  today: "nav-today",
  network: "nav-network",
  communities: "nav-communities",
};

export const DASHBOARD = {
  root: "dashboard-root",
  scoreCard: "dashboard-score-card",
  runDiagnostic: "dashboard-run-diagnostic",
  moduleCard: "dashboard-module-card",
};

export const PROFILE = {
  root: "profile-root",
  headline: "profile-headline",
  summary: "profile-summary",
  currentRole: "profile-current-role",
  years: "profile-years",
  targetRoles: "profile-target-roles",
  locations: "profile-locations",
  industries: "profile-industries",
  languages: "profile-languages",
  skills: "profile-skills",
  linkedin: "profile-linkedin",
  save: "profile-save",
  runDiagnostic: "profile-run-diagnostic",
  diagnosticResult: "profile-diagnostic-result",
};

export const INTELLIGENCE = {
  root: "intelligence-root",
  scoreValue: "intelligence-score-value",
  scoreBand: "intelligence-score-band",
  narrativeBtn: "intelligence-narrative-btn",
  recosBtn: "intelligence-recos-btn",
  recoCard: "intelligence-reco-card",
  dimensionRow: "intelligence-dimension-row",
};

export const OPPORTUNITIES = {
  root: "opportunities-root",
  matchBtn: "opportunities-match-btn",
  filterAll: "opportunities-filter-all",
  filterVisible: "opportunities-filter-visible",
  filterHidden: "opportunities-filter-hidden",
  card: "opportunities-card",
  saveBtn: "opportunities-save-btn",
  applyBtn: "opportunities-apply-btn",
  dismissBtn: "opportunities-dismiss-btn",
};

export const FOUNDER = {
  root: "founder-root",
  selfPromote: "founder-self-promote",
  flagRow: "founder-flag-row",
  flagToggle: "founder-flag-toggle",
};

export const PARTNER = {
  // Register
  orgName: "partner-org-name",
  orgKind: "partner-org-kind",
  country: "partner-country",
  region: "partner-region",
  website: "partner-website",
  contactName: "partner-contact-name",
  contactEmail: "partner-contact-email",
  contactPassword: "partner-contact-password",
  submit: "partner-register-submit",
  // Console
  consoleRoot: "partner-console-root",
  metricTotal: "partner-metric-total",
  inviteEmail: "partner-invite-email",
  inviteCreate: "partner-invite-create",
  inviteRow: "partner-invite-row",
  // Directory
  directoryRoot: "partner-directory-root",
  directoryRow: "partner-directory-row",
  approveBtn: "partner-approve-btn",
};

export const ASSISTANT = {
  root: "assistant-root",
  input: "assistant-input",
  send: "assistant-send",
  message: "assistant-message",
};

export const PROFESSIONALS = {
  root: "professionals-root",
  searchBtn: "professionals-search-btn",
  specialtyFilter: "professionals-specialty-filter",
  languageFilter: "professionals-language-filter",
  modalityFilter: "professionals-modality-filter",
  freeFirstFilter: "professionals-free-first-filter",
  card: "professionals-card",
  bookBtn: "professionals-book-btn",
  bookDialog: "professionals-book-dialog",
  bookModality: "professionals-book-modality",
  bookSlot: "professionals-book-slot",
  bookTopic: "professionals-book-topic",
  bookSubmit: "professionals-book-submit",
  myBookings: "professionals-my-bookings",
  applyBtn: "professionals-apply-btn",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
